import { Vector3 } from "three";

// Приводим userData.bSize к THREE.Vector3, если есть
export const bSizeToVector3 = (obj) => {
    if (obj.userData && obj.userData.bSize) {
        const bSize = obj.userData.bSize;
        if (!(bSize instanceof Vector3)) {
            obj.userData.bSize = new Vector3(bSize.x, bSize.y, bSize.z);
        }
    }
};
